import React from 'react';
import { useWorkspace } from '../contexts/WorkspaceContext';

const Logo = ({ size = 'md', className = '', showText = true, variant = 'main' }) => {
  const { workspace, isMainApp } = useWorkspace();
  
  const sizeClasses = {
    sm: { image: 'h-6 w-6', text: 'text-lg' },
    md: { image: 'h-8 w-8', text: 'text-xl' },
    lg: { image: 'h-10 w-10', text: 'text-2xl' },
    xl: { image: 'h-12 w-12', text: 'text-3xl' }
  };

  const currentSize = sizeClasses[size] || sizeClasses.md;
  
  // Use workspace logo if available, otherwise default Lexa logo
  // Using footer-icon.png as the unified logo across all headers and footers
  const hasWorkspaceLogo = !isMainApp && workspace?.settings?.logo_url;
  const imageSrc = hasWorkspaceLogo 
    ? workspace.settings.logo_url
    : '/assets/footer-icon.png';
  
  // Workspace primary color for text gradient
  const primaryColor = workspace?.settings?.primary_color || '#9333ea';
  const textGradient = hasWorkspaceLogo 
    ? `linear-gradient(to right, ${primaryColor}, #3b82f6)`
    : 'linear-gradient(to right, #9333ea, #3b82f6)';
  
  // Display name: workspace name when on subdomain, otherwise Lexa.run
  const displayName = hasWorkspaceLogo && workspace?.name 
    ? workspace.name 
    : 'Lexa.run';

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className="flex-shrink-0">
        <img 
          src={imageSrc} 
          alt={`${displayName} Logo`}
          className={`${currentSize.image} object-contain`}
          style={{ maxWidth: 'none' }}
          onError={(e) => {
            // Fallback to default logo if workspace logo fails to load
            e.target.src = '/assets/footer-icon.png';
          }}
        />
      </div>
      {showText && (
        <div>
          <h1 
            className={`${currentSize.text} font-bold bg-clip-text text-transparent`}
            style={{ backgroundImage: textGradient }}
          >
            {displayName}
          </h1>
          {(size === 'lg' || size === 'xl') && !hasWorkspaceLogo ? (
            <p className="text-sm text-gray-600">AI-Powered Test Automation</p>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default Logo;